import { FC } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';

// interface that extends GridCellProps
interface EmailCellProps extends GridCellProps {
  linked?: boolean;
}

const EmailCell: FC<React.PropsWithChildren<EmailCellProps>> = ({ dataItem, field, linked }) => {
  const email = dataItem[field];
  return (
    <td>
      {email && (
        <>
          {linked ? (
            <a href={`mailto:${email}`} className="text-link">
              {email}
            </a>
          ) : (
            email
          )}
        </>
      )}
    </td>
  );
};

export default EmailCell;
